import httpInstance from './httpInstance';

class httpClient {

  //封装http GET
  get(uri, params, config) {
    config = config ? config : {};
    config.method = 'get';
    return this.ajax(uri, {params: params}, config);
  }

  //封装http POST
  post(uri, params, config) {
    config = config ? config : {};
    config.method = 'post';
    return this.ajax(uri, params, config);
  }

  //封装http PUT
  put(uri, params, config) {
    config = config ? config : {};
    config.method = 'put';
    return this.ajax(uri, params, config);
  }

  //封装http DELETE
  delete(uri, params, config) {
    config = config ? config : {};
    config.method = 'delete';
    return this.ajax(uri, params, config);
  }

  ajax(uri, params, config) {
    config = config ? config : {};
    var settings = {check: true, method: 'get'};
    for (var key in config) {
      settings[key] = config[key];
    }

    //FormData上传图片时不序列化params，post和put时序列化params
    if ((settings.method === 'post' && (params instanceof FormData)) || settings.method === 'put' || settings.method === 'delete') {
      //params = qs.stringify(params);
    }

    if (config.headers && !config.headers['Content-Type']) {
      if (params instanceof FormData) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
      } else {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
      }
    }

    //delete的传参
    if (settings.method === 'delete') {
      uri += '?' + params;
    }

    return httpInstance[settings.method](uri, params);
  }

}

export default new httpClient();
